/** @jsx jsx */
import * as React from "react";
import { css, jsx } from "@emotion/core"
import { inAppNotificationStyles } from "../styles/components/InAppNotification";
import { NetworkQualityBandwidthStats } from "twilio-video";
import {IConsultationUpdateParams} from "../models/appointment/IConsultationUpdateParams";
import {ApiManager} from "../api/ApiManager";
import {IAppointmentScheduleResponse} from "@curefit/care-common"
import MarkDelaySuccessModal from "./MarkDelaySuccessModal";

export interface IAppNotificationEventData {
    isVisible: boolean;
    title: string;
    subtitle: string
    ctas: { text: string, onClick(): void }[];
    iconText: number;
    appointment: IAppointmentScheduleResponse
}

export interface IAppNotificationState extends IAppNotificationEventData {
    showDelayOptions: boolean,
    showSuccessModal: boolean,
    delayedInMinutes: number
}

export interface IAppNotificationProps {

}


export class InAppNotificationComponent extends React.Component<IAppNotificationProps, IAppNotificationState>{

    public static SHOW_NOTIFICATION_EVENT: string = "SHOW_NOTIFICATION_EVENT";
    private intervalId: any;

    constructor(props: IAppNotificationProps) {
        super(props);
        this.state = {
            isVisible: false,
            title: "",
            subtitle: "",
            ctas: [],
            iconText: undefined,
            showDelayOptions: false,
            showSuccessModal: false,
            appointment: null,
            delayedInMinutes: null
        };
        this.startCountdownTimer = this.startCountdownTimer.bind(this);
    }
    componentDidMount() {
        document.addEventListener(InAppNotificationComponent.SHOW_NOTIFICATION_EVENT, (e: CustomEvent) => {
            if (!this.state.isVisible) {
                this.setState({ isVisible: true, ...e.detail }, this.startCountdownTimer)
            }
        });
    }
    componentWillUnmount() {
        document.removeEventListener(InAppNotificationComponent.SHOW_NOTIFICATION_EVENT, () => { });
        clearInterval(this.intervalId);
    }

    startCountdownTimer() {
        this.intervalId = setInterval(() => {
            const currentTimeRemaining = this.state.iconText;
            if (currentTimeRemaining > 0) {
                this.setState({ iconText: currentTimeRemaining - 1 });
            }
        }, 60000)

    }

    handleMarkDelayClick = () => {
        this.setState(prevState => ({
            // showDelayOptions: !prevState.showDelayOptions
            isVisible: false
        }))
    }

    handleOptionClick = (delayedInMinutes: number) => {
        const consultationUpdateParams: IConsultationUpdateParams = {
            delayedInMinutes
        }
        ApiManager.getAlbusApis().updateAppointment(this.state.appointment.bookingId, this.state.appointment.id, consultationUpdateParams).then(() => {
            this.setState({
                showDelayOptions: false,
                delayedInMinutes,
                showSuccessModal: true,
                isVisible: false
            })
        }).catch((e: any) => {
            console.log(e)
        });
    }

    render() {
        const { isVisible, title, subtitle, ctas, iconText } = this.state;
        return (<React.Fragment>
            {isVisible &&
                <div css={inAppNotificationStyles.notificationContainer} id="inappNotifiactionCntainer">
                    <div css={inAppNotificationStyles.notificationLeft}>
                        <div css={inAppNotificationStyles.notifiactionIconContainer}>
                            <div css={inAppNotificationStyles.notificationIcon}>
                                {iconText}
                            </div>
                        </div>
                        <div css={inAppNotificationStyles.notificationTextContainer}>
                            <div>
                                <div css={inAppNotificationStyles.notifiactionTitle}>{title}</div>
                                <div css={inAppNotificationStyles.notificationSubTitle}>{subtitle}</div>
                            </div>
                        </div>
                    </div>
                    <div css={inAppNotificationStyles.notificationRight}>
                        <div css={inAppNotificationStyles.notificationActionTop} onClick={() => this.setState({ isVisible: false })}>
                            Dismiss
                        </div>
                        <div css={inAppNotificationStyles.notificationActionBottom} onClick={this.handleMarkDelayClick}>
                            <span>Mark Delay</span>
                            <div css={inAppNotificationStyles.delayOptionsContainer(this.state.showDelayOptions)}>
                                <div css={inAppNotificationStyles.delayOption} onClick={() => this.handleOptionClick(5)}>{"5 Mins"}</div>
                                <div css={inAppNotificationStyles.delayOption} onClick={() => this.handleOptionClick(10)}>{"10 Mins"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {this.state.showSuccessModal &&
                <div css={inAppNotificationStyles.notificationContainer}>
                    <div css={inAppNotificationStyles.notificationLeft}>
                        <img src="/images/icons/check.svg" />
                        <div css={inAppNotificationStyles.successText}>{`Upcoming appointment is now Delayed by 5 mins`}</div>
                    </div>
                    <div css={inAppNotificationStyles.notificationRight}>
                        <div css={inAppNotificationStyles.notificationActionTop} onClick={() => this.setState({ showSuccessModal: false })}>
                            Dismiss
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
        )
    }
}